"use strict"; // @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)

Object.defineProperty(exports, "__esModule", {
  value: true
});